module.exports = __webpack_public_path__ + "assets/img/2.8188ccc3.jpg";